<script>
import {resolveRevisionImageUrl} from "@/Composables/DeviceImage.js";

export default {
	name: "HardwareConfigurationCard",
	props: {
		config: {
			type: Object,
			required: true,
		},
	},
  computed: {
    getSubHeading(){
      return [
        this.config.device_revision?.device_model?.name,
        this.config.device_revision?.device_type?.name,
      ].filter(_ => _ !== null).join(' / ');
    },
    getImageUrl() {
      return resolveRevisionImageUrl(this.config.device_revision, 'https://placehold.co/600x400')
    },
  },
}
</script>

<template>
	<Card :pt="{header: { style: { 'border-bottom': '0px' }}}">
		<template #header>
			<div class="h-30 aspect-video mx-6 mt-6 rounded-md inline-flex items-center justify-center">
        <img :src="getImageUrl" alt="config image" class="h-full mx-auto"/>
			</div>
		</template>
		<template #subtitle>{{ getSubHeading }}</template>
		<template #content>
      <div class="-mt-7 ">
        <span class="text-sm font-semibold text-blue-600 flex">{{ config.device_revision?.name ?? $t('common.na') }}</span>
        <span class="text-sm font-semibold text-green-700 flex">{{ config.firmware?.version_number ?? $t('common.na') }}</span>
      </div>
		</template>
	</Card>
</template>

<style scoped>

</style>
